
export default function TermsOfServiceUa() {
  return (
    <div className={` inset-0 top-[150px] max-w-7xl mt-20`}>
      <>

        <>
          <header>
            <h1 className="text-[#2a7a2a] text-center text-4xl">Умови використання сайту</h1>
          </header>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>
              ЗГОДА З УМОВАМИ ВИКОРИСТАННЯ
              <br />
            </strong>
          </h2>{" "}
          <br /><p><small>Останнє оновлення: 12.08.2022.</small></p>
          <br /><p>
            Ці Умови використання сайту є юридично зобов’язуючою угодою, укладеною між
            Вами особисто чи від імені організації («Ви») та SerhiiShevchenko.com
            («Компанія», «Ми», «Нас», «Нами» або «Наш»), щодо Ваших доступів і
            використання наших продуктів, послуг, веб-сайту, а також будь-якого іншого
            медіа-каналу, пов’язаного з нами або іншим чином пов’язаного з Нами (разом
            «Сайт»).
          </p>
          <br /><p>
            Ви погоджуєтеся, що, відвідуючи Сайт, Ви прочитали, зрозуміли та
            погоджуєтеся дотримуватися всіх цих Умов використання сайту та надання
            послуг. Якщо Ви не згодні з усіма цими Умовами використання, Вам прямо
            заборонено використовувати Сайт, і Ви повинні негайно припинити його
            використання.
          </p>
          <br /><p>
            Додаткові Умови використання або документи, які час від часу можуть
            публікуватися на Сайті, прямо включені в цей документ шляхом посилання. Ми
            залишаємо за собою право на власний розсуд вносити зміни або модифікації в
            ці Умови використання в будь-який час і з будь-якої причини.
          </p>
          <br /><p>
            Ми повідомимо Вас про будь-які зміни, оновивши дату останнього оновлення цих
            Умов використання, і Ви відмовляєтесь від будь-якого права отримувати
            конкретне сповіщення про кожну таку зміну. Однак ми можемо повідомити Вас
            про деякі важливі зміни цих Умов використання електронною поштою або іншим
            способом зв’язку.
          </p>
          <br /><p>
            Ви зобов’язані періодично переглядати ці Умови використання, щоб бути в
            курсі оновлень. На Вас поширюватимуться зміни в будь-яких переглянутих
            Умовах використання, і вважатиметься, що Ви ознайомлені з ними та приймаєте
            їх, якщо продовжуватимете користуватися Сайтом після дати публікації таких
            переглянутих Умов використання та надання послуг.
          </p>
          <br /><p>
            Сайт призначений для користувачів, яким виповнилося 18 років. Особи віком до
            18 років не мають права реєструватися на Сайті. Будь-яка реєстрація,
            використання або доступ до будь-якого з наших Продуктів, Послуг чи іншого
            Вмісту особами віком до 18 років є неавторизованою, неліцензованою та
            порушує ці Умови використання та надання послуг. Отримуючи доступ або
            використовуючи наші Продукти, Послуги чи інший Вміст, Ви заявляєте та
            гарантуєте, що Вам виповнилося 18 років.
          </p>
          <br /><p>
            Ці Умови використання вимагають використання арбітражу на індивідуальній
            основі для вирішення суперечок, а не судів присяжних, і обмежують засоби
            правового захисту, доступні Вам у разі вирішення суперечок. Ви повністю
            розумієте та погоджуєтеся з тим, що, реєструючись, купуючи та/або
            використовуючи будь-який із наших Продуктів, Послуг та інших матеріалів, Ви
            відмовляєтеся від певних юридичних прав і добровільно погоджуєтеся це
            зробити.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ПРАВО ІНТЕЛЕКТУАЛЬНОЇ ВЛАСНОСТІ</strong>
          </h2>
          <p>
            Якщо не вказано інше, Сайт є нашою власністю та весь вихідний код, бази
            даних, функціональність, програмне забезпечення, дизайн веб-сайтів, аудіо,
            відео, текст, фотографії, графіка та будь-який інший вміст на Сайті (разом
            «Вміст») і торгові марки, знаки обслуговування та логотипи, що містяться в
            них («Знаки»), належать або контролюються нами або надані нам за ліцензією,
            і захищені законами про авторське право та торговельні марки та різними
            іншими правами інтелектуальної власності.
          </p>
          <br /><p>
            Вміст і Знаки надаються на Сайті «ЯК Є» лише для Вашої інформації та
            особистого використання. За винятком випадків, прямо передбачених цими
            Умовами використання та надання послуг, жодну частину Сайту, а також Вміст
            або Знаки заборонено копіювати, відтворювати, агрегувати, повторно
            публікувати, завантажувати, публічно демонструвати, кодувати, перекладати,
            передавати, поширювати, продавати, ліцензувати або іншим чином
            використовувати з будь-якою комерційною метою без нашого прямого
            попереднього письмового дозволу.
          </p>
          <br /><p>
            За умови, що Ви маєте право використовувати Сайт, Вам надається обмежена
            ліцензія на доступ і використання Сайту, а також на завантаження або друк
            копії будь-якої частини Вмісту, до якої Ви належним чином отримали доступ,
            виключно для ваших особистих, некомерційних цілей. Ми залишаємо за собою всі
            права на Сайт, Вміст і Знаки, які не надані Вам прямо.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ВІДПОВІДАЛЬНІСТЬ КОРИСТУВАЧІВ</strong>
          </h2>
          <p>Використовуючи Сайт, Ви заявляєте та гарантуєте, що:</p>
          <p>
            (1) уся надана Вами реєстраційна інформація буде правдивою, точною,
            актуальною та повною;
          </p>
          <p>
            (2) Ви будете підтримувати точність такої інформації та оперативно
            оновлювати таку реєстраційну інформацію, якщо необхідно;
          </p>
          <p>
            (3) Ви маєте правоздатність і погоджуєтеся дотримуватися цих Умов
            використання;
          </p>
          <p>(4) Вам виповнилося 18 років;</p>
          <p>
            (5) Ви не отримуватимете доступ до Сайту за допомогою автоматизованих чи
            нелюдських засобів, будь то через бота, скрипт чи іншим чином;
          </p>
          <p>
            (6) Ви не використовуватимете Сайт для будь-яких незаконних або
            неавторизованих цілей;
          </p>
          <p>
            (7) Використання Вами Сайту не порушуватиме жодних чинних законів чи
            нормативних актів.
          </p>
          <br /><p>
            Якщо Ви надаєте будь-яку інформацію, яка є неправдивою, неточною,
            неактуальною або неповною, ми маємо право призупинити або припинити дію
            Вашого облікового запису та відмовити в будь-якому поточному чи майбутньому
            використанні Сайту (або будь-якої його частини).
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>РЕЄСТРАЦІЯ КОРИСТУВАЧА</strong>
          </h2>
          <p>
            Вам може знадобитися зареєструватися на Сайті. Ви погоджуєтеся зберігати
            конфіденційність свого пароля та несете відповідальність за будь-яке
            використання Вашого облікового запису та пароля. Ви не маєте права нікому
            повідомляти своє ім’я користувача та/або пароль. Якщо ми дізнаємося, що Ви
            надали своє ім’я користувача та/або пароль іншій особі, ми залишаємо за
            собою право негайно припинити Ваш доступ до Сайту, Контенту чи будь-якого
            іншого нашого Продукту чи Сервісу, який Ви використовували. Ви несете
            відповідальність за захист свого пароля від розголошення іншим. Ми не можемо
            і не будемо нести відповідальність за будь-які втрати або збитки, спричинені
            Вами через те, що Ви не захистили свій пароль або інформацію облікового
            запису. Ми залишаємо за собою право видалити, відновити або змінити вибране
            Вами ім’я користувача, якщо ми на власний розсуд визначимо, що таке ім’я
            користувача є неприйнятним, непристойним або іншим чином неприйнятним.
          </p>
          <br /><p>
            Ви погоджуєтеся негайно повідомляти нас про будь-яке несанкціоноване
            використання Вашого пароля чи облікового запису чи будь-яке інше порушення
            безпеки, а також гарантувати, що Ви виходите зі свого облікового запису в
            кінці кожного сеансу. Використовуючи Сайт і/або Вміст, Ви погоджуєтеся
            вводити правдиву та точну інформацію під час реєстрації, процесу покупки
            тощо. Якщо Ви введете неправдиву інформацію, ми маємо право негайно
            деактивувати Ваш обліковий запис. Ми докладатимемо всіх зусиль, щоб Ваші
            паролі залишалися конфіденційними, і не будемо розголошувати Ваші паролі без
            Вашої згоди, за винятком випадків, коли цього вимагає закон або якщо в Нас
            буде достатня причина вважати, що така дія необхідна, особливо коли
            розголошення необхідне, щоб ідентифікувати когось, зв’язатися з ним або
            подати судовий позов проти когось, хто може завдавати шкоди іншим або
            втручатися в наші права чи власність.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ЗАБОРОНЕНА ДІЯЛЬНІСТЬ</strong>
          </h2>
          <p>
            Ви не можете отримувати доступ або використовувати Сайт для будь-яких цілей,
            крім тих, для яких ми надаємо доступ до Сайту. Сайт не можна використовувати
            в будь-яких комерційних цілях, за винятком тих, які спеціально схвалені або
            схвалені нами.
          </p>
          <br /><p>Як користувач Сайту Ви погоджуєтеся НЕ робити наступних речей:</p>
          <ol style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>
              Систематично отримувати дані або інший вміст із Сайту для створення або
              компіляції, прямо чи опосередковано, колекції, компіляції, бази даних чи
              каталогу без нашого письмового дозволу.
            </li>
            <li>
              Брати участь у неналежному та/або несанкціонованому використанні Сайту
              та/або Вмісту. Неналежне та несанкціоноване використання включає, але не
              обмежується модифікацією, копіюванням, відтворенням, повторним
              опублікуванням, завантаженням, публікацією, передачею, перекладом,
              продажем, створенням похідних робіт, використанням або розповсюдженням
              будь-яким способом або засобом (в тому числі електронною поштою чи іншими
              електронними засобами) будь-якого Вмісту або будь-якої іншої інформації,
              доступ до якої отриманий або придбаний через наші Продукти, Послуги, або
              будь-яке інше повідомлення, надане нами для Вашого особистого
              користування, з метою використання в бізнесі/комерції або будь-яким
              способом, який приносить Вам прибуток.
            </li>
            <li>
              Копіювати, розповсюджувати, обмінювати, продавати чи іншим чином
              поширювати будь-яку частину Сайту чи Вмісту будь-якій іншій особі для
              їхнього особистого використання, ділового/комерційного використання або
              будь-яким способом, який приносить їм прибуток, незалежно від того, було
              це Вам відомо чи ні на той момент, коли Ви поділилися інформацією, їхній
              намір полягав у використанні Вмісту для особистого використання або
              використання в бізнесі/комерції. Це означає, що Ви не можете ділитися або
              продавати будь-яку частину Сайту та/або Вмісту комусь іншому, щоб вони
              могли копіювати та/або використовувати їх для власного особистого
              використання, ділового/комерційного використання або будь-яким способом,
              який приносить їм прибуток. Ви єдиний, кому надано обмежену ліцензію на
              використання Сайту та/або Вмісту.
            </li>
            <li>
              Порушувати будь-яким іншим способом наші права на інтелектуальну
              власність, включаючи авторські права та права на товарні знаки.
            </li>
            <li>
              Обходити, відключати або іншим чином втручатися в пов’язані з безпекою
              функції Сайту, включаючи функції, які запобігають або обмежують
              використання або копіювання будь-якого Вмісту або встановлюють обмеження
              на використання Сайту та/або Вмісту, що міститься на ньому.
            </li>
            <li>
              Обманювати або вводити нас та/або інших користувачів в оману, особливо під
              час будь-яких спроб дізнатися конфіденційну інформацію облікового запису,
              таку як паролі користувачів.
            </li>
            <li>
              Використовувати наші служби підтримки неналежним чином або надсилати
              неправдиві звіти про зловживання чи неправомірну поведінку.
            </li>
            <li>
              Будь-яке автоматизоване використання системи, наприклад, використання
              скриптів для надсилання коментарів чи повідомлень або використання
              будь-якого інтелектуального аналізу даних, роботів чи подібних
              інструментів збору та вилучення даних.
            </li>
            <li>
              Втручатися, порушувати або створювати надмірне навантаження на Сайт або
              мережі чи служби, підключені до Сайту.
            </li>
            <li>Продавати або іншим чином передавати свій профіль.</li>
            <li>
              Використовувати будь-яку інформацію, отриману з Сайту, щоб переслідувати,
              образити або завдати шкоди іншій особі.
            </li>
            <li>
              Використовувати Сайт як частину будь-яких спроб конкурувати з нами або
              іншим чином використовувати Сайт та/або Вміст для будь-якої прибуткової
              діяльності чи комерційного підприємства.
            </li>
            <li>
              Розшифровувати, декомпілювати, розбирати або здійснювати зворотний
              інженерний аналіз будь-якого програмного забезпечення, що входить до
              складу Сайту або будь-яким чином є його частиною.
            </li>
            <li>
              Намагатися обійти будь-які заходи Сайту, призначені для запобігання або
              обмеження доступу до Сайту чи будь-якої його частини.
            </li>
            <li>
              Переслідувати, дратувати, залякувати або погрожувати будь-якому з наших
              співробітників або агентів, які займаються наданням Вам будь-якої частини
              Сайту.
            </li>
            <li>
              Копіювати або адаптувати програмне забезпечення Сайту, включаючи, але не
              обмежуючись, Flash, PHP, HTML, JavaScript або інший код.
            </li>
            <li>
              Завантажувати або передавати (або намагатися завантажити або передати)
              віруси, трояни чи інший матеріал, у тому числі надмірне використання
              великих літер і спам (безперервне розміщення повторюваного тексту), що
              заважає будь-якій стороні безперервно використовувати та насолоджуватися
              Сайтом або модифікує, погіршує, порушує, змінює або втручається у
              використання, особливості, функції, роботу чи обслуговування Сайту та/або
              завдає шкоди Сайту та Компанії будь-яким іншим способом.
            </li>
            <li>
              Використовувати Сайт у спосіб, який не відповідає будь-яким чинним законам
              чи нормам, або у спосіб, який не був дозволений нами за нашою попередньою
              письмовою згодою.
            </li>
          </ol>
          <br /><p>
            Ви розумієте та погоджуєтеся, що участь у забороненому або неналежному
            та/або несанкціонованому використанні Сайту та Вмісту, як зазначено в цих
            Умовах використання, вважається порушенням та/або крадіжкою, і ми залишаємо
            за собою право переслідувати ці порушення в повному обсязі відповідно до
            закону.
          </p>
          <br /><p>
            Ви погоджуєтесь і розумієте, що заборонене, неналежне та/або несанкціоноване
            використання може призвести до цивільного позову про відшкодування збитків
            і/або бути кримінальним злочином.
          </p>
          <br /><p>
            Будь-який запит на отримання письмового дозволу на використання Вмісту,
            повністю чи частково, або будь-якої іншої інтелектуальної власності або
            майна, що належить нам («Вміст»), має бути зроблено ДО того, як Ви захочете
            його використовувати, заповнивши форму «Зв’язатися з нами» на Сайті або
            надіславши електронний лист на адресу {import.meta.env.VITE_MY_WORK_EMAIL}
          </p>
          <br /><p>
            Ми дуже чітко заявляємо, що Ви не можете використовувати Сайт та/або Вміст,
            повністю чи частково, будь-яким способом, який суперечить цим Умовам
            використання, якщо ми не надамо Вам на це письмовий дозвіл. Якщо Ви отримали
            від нас дозвіл, Ви погоджуєтеся використовувати певний Вміст, який ми
            дозволяємо, і ТІЛЬКИ у спосіб, на який ми надали Вам наш письмовий дозвіл.
          </p>
          <br /><p>
            Якщо Ви вирішите використовувати вміст у спосіб, на який ми не надаємо Вам
            письмовий дозвіл, то Ви погоджуєтеся, що Ваші дії будуть розцінені так, ніби
            Ви скопіювали та/або вкрали такий вміст у нас, і Ви погоджуєтеся негайно
            припинити використання такого Вмісту та вживати будь-яких дій, які ми можемо
            вимагати, методами та в терміни, які ми призначаємо для захисту нашої
            інтелектуальної власності та прав власності на Сайт і Вміст.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ВНЕСОК КОРИСТУВАЧІВ</strong>
          </h2>
          <p>
            Сайт може запрошувати Вас спілкуватися, співпрацювати, робити внески або
            брати участь у блогах, соціальних мережах, онлайн-форумах та інших каналах
            комунікації, а також може надавати Вам можливість створювати, надсилати,
            публікувати, відображати, передавати, виконувати, публікувати, поширювати,
            або транслювати вміст і матеріали нам або на Сайті, включаючи, але не
            обмежуючись, тексти, відео, аудіо, фотографії, графіки, коментарі,
            пропозиції або особисту інформацію чи інші матеріали (разом «Внесок»).
          </p>
          <br /><p>
            Внески можуть переглядати інші користувачі Сайту та сторонні веб-сайти.
            Таким чином, будь-який внесок, який Ви передаєте, може розглядатися як
            неконфіденційний і невласний. Коли Ви створюєте або робите доступними
            будь-які внески, Ви тим самим заявляєте та гарантуєте, що:
          </p>
          <ol style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>
              Створення, розповсюдження, передача, публічний показ або виконання, а
              також доступ, завантаження чи копіювання Ваших Внесків не порушують і не
              будуть порушувати права власності, включаючи, але не обмежуючись,
              авторське право, патент, торгову марку, комерційну таємницю або немайнові
              права будь-якої третьої сторони.
            </li>
            <li>
              Ви є творцем і власником або маєте необхідні ліцензії, права, згоди,
              випуски та дозволи на використання та дозвіл Нам, Сайту та іншим
              користувачам Сайту використовувати Ваші Внески будь-яким способом,
              передбаченим Сайтом і цими Умови використання.
            </li>
            <li>
              Ви маєте письмову згоду та/або дозвіл кожної окремої особи, яку можна
              ідентифікувати у Ваших Внесках, на використання імені чи зображення кожної
              окремої особи, яку можна ідентифікувати, щоб дозволити включення та
              використання Ваших Внесків будь-яким способом, передбаченим цим Сайтом і
              цими Умовами використання.
            </li>
            <li>
              Ваші Внески не є фальшивими, неточними чи такими, що вводять в оману.
            </li>
            <li>
              Ваші Внески не є небажаною або несанкціонованою рекламою, рекламними
              матеріалами, фінансовими пірамідами, спамом, масовими розсилками чи іншими
              формами настирливого прохання.
            </li>
            <li>
              Ваші Внески не є непристойними, брудними, насильницькими, образливими,
              наклепницькими чи іншими неприйнятними (на нашу думку).
            </li>
            <li>
              Ваші Внески не висміюють, не знущаються, не принижують, не залякують і не
              ображають когось.
            </li>
            <li>
              Ваші Внески не пропагують насильницького повалення будь-якого уряду, не
              підбурюють, не заохочують і не погрожують завдати фізичної шкоди іншим.
            </li>
            <li>
              Ваші Внески не порушують жодного чинного закону, нормативного акту чи
              правила.
            </li>
            <li>
              Ваші Внески не порушують права на конфіденційність чи публічність
              будь-якої третьої сторони.
            </li>
            <li>
              Ваші Внески не містять жодних матеріалів, які збирають особисту інформацію
              від осіб віком до 18 років або використовують осіб віком до 18 років у
              сексуальному чи насильницькому порядку.
            </li>
            <li>
              Ваші Внески не порушують жодного федерального закону чи закону штату, що
              стосується дитячої порнографії, або іншим чином призначені для захисту
              здоров’я чи благополуччя неповнолітніх.
            </li>
            <li>
              Ваш Внесок не містить образливих коментарів щодо раси, національного
              походження, статі, сексуальних уподобань чи фізичних недоліків.
            </li>
            <li>
              Ваші Внески не порушують жодних положень цих Умов використання або
              будь-якого чинного закону чи нормативного акту, а також не посилаються на
              матеріали, які порушують.
            </li>
          </ol>
          <br /><p>
            Будь-яке використання Сайту з порушенням будь-якого з вищенаведених пунктів
            порушує ці Умови використання та може призвести, серед іншого, до припинення
            або призупинення Ваших прав на використання Сайту.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ЛІЦЕНЗІЯ НА ВНЕСОК</strong>
          </h2>
          <p>
            Публікуючи свої Внески в будь-якій частині Сайту або надаючи доступ до
            Внесків на Сайті, пов’язуючи свій обліковий запис на Сайті з будь-яким із
            Ваших облікових записів у соціальних мережах, Ви автоматично надаєте,
            заявляєте та гарантуєте, що маєте право надавати, нам і будь-кому,
            уповноваженому нами, необмежене, безвідкличне, безстрокове, неексклюзивне,
            передаване, безкоштовне, всесвітнє право та ліцензію на розміщення,
            використання, копіювання, відтворення, розкриття, продаж, перепродаж ,
            публікування, транслювання, змінення назви, архівування, зберігання,
            кешування, публічне виконання, публічне демонстрування, переформатування,
            перекладання, передавання, створення уривків (повністю чи частково) і
            поширення таких Внесків (включаючи, але не обмежуючись, Ваші зображення та
            голос) з будь-якою метою, комерційною, рекламною чи іншою, а також готувати
            похідні роботи або включати в інші роботи такі Внески, а також надавати та
            дозволяти субліцензії на вищезазначене. Використання та розповсюдження може
            відбуватися в будь-яких медіа-форматах і через будь-які медіа-канали.
          </p>
          <br /><p>
            Ця ліцензія поширюватиметься на будь-яку форму, носії чи технологію, відому
            зараз або розроблену в майбутньому, і включає використання нами Вашого
            імені, назви компанії, якщо це застосовно, а також будь-яких торгових марок,
            знаків обслуговування, торгових назв, логотипів, а також особистих і
            комерційних зображень, які Ви надаєте. Ви відмовляєтеся від усіх моральних
            прав на Ваші Внески та гарантуєте, що моральні права не заявлялися іншим
            чином у Ваших Внесках.
          </p>
          <br /><p>
            Ми не заявляємо про право власності на Ваші внески. Ви зберігаєте повне
            право власності на всі Ваші Внески та будь-які права інтелектуальної
            власності чи інші права власності, пов’язані з Вашими Внесками. Ми не несемо
            відповідальності за будь-які заяви у Ваших Внесках, наданих Вами в будь-якій
            частині Сайту.
          </p>
          <br /><p>
            Ви несете одноосібну відповідальність за свій Внесок на Сайт і погоджуєтеся
            звільнити нас від будь-якої відповідальності та утриматися від будь-яких
            судових позовів проти нас щодо Ваших Внесків.
          </p>
          <br /><p>
            Ми маємо право на власний розсуд (1) редагувати, приховувати певні частини
            чи іншим чином змінювати будь-який Внесок; (2) змінювати категорію будь-яких
            Внесків, щоб розмістити їх у більш відповідних місцях на Сайті; і (3)
            попередньо переглядати або видаляти будь-які Внески в будь-який час і з
            будь-якої причини, без повідомлення. Ми не зобов’язані контролювати Ваші
            Внески.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ВАША ЗГОДА</strong>
          </h2>
          <p>
            Ви визнаєте та погоджуєтеся з тим, що будь-які запитання, коментарі,
            пропозиції, ідеї, відгуки чи інша інформація щодо Сайту («Подання»), надана
            Вами нам, не є конфіденційною та стане нашою виключною власністю. Ми
            володіємо виключними правами, включно з усіма правами інтелектуальної
            власності, і маємо право на необмежене використання та розповсюдження цих
            матеріалів для будь-яких законних цілей, комерційних чи інших, без
            підтвердження або компенсації Вам.
          </p>
          <br /><p>
            Таким чином продовжуючи користуватися Сайтом Ви відмовляєтеся від усіх
            моральних прав на будь-яке таке Подання, і Ви гарантуєте, що будь-яке таке
            Подання є Вашим оригінальним або що Ви маєте право подавати такі Подання. Ви
            погоджуєтеся, що проти Нас не буде позовів за будь-яке ймовірне чи фактичне
            порушення або незаконне привласнення будь-якого права власності на Ваші
            Подані дані.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>СТОРОННІ ВЕБ-САЙТИ ТА ВМІСТ</strong>
          </h2>
          <p>
            Сайт може містити (або Вас можуть надсилати через Сайт) посилання на інші
            веб-сайти («Сторонні веб-сайти»), а також статті, фотографії, текст,
            графіку, зображення, дизайн, музику, звук, відео, інформацію, програми,
            програмне забезпечення та інший вміст або предмети, що належать або походять
            від третіх осіб («Вміст третіх сторін»).
          </p>
          <br /><p>
            Такі Сторонні веб-сайти та Вміст третіх сторін Нами не досліджуються, не
            контролюються та не перевіряються на точність, відповідність чи повноту, і
            ми не несемо відповідальності за будь-які сторонні веб-сайти, доступ до яких
            здійснюється через Наш Сайт, або будь-який опублікований Вміст третіх
            сторін, що розміщений на, доступний через або встановлений на Сайті,
            включаючи вміст, точність, образливість, думки, надійність, методи
            конфіденційності або інші політики Веб-сайтів Третіх Сторін або Вмісту
            третіх сторін.
          </p>
          <br /><p>
            Включення будь-яких Веб-сайтів Третіх Сторін чи будь-якого Вмісту третіх
            сторін, посилання на них або надання дозволу на використання чи встановлення
            будь-яких Веб-сайтів Третіх Сторін не означає їх схвалення нами. Якщо Ви
            вирішите залишити Наш Сайт і отримати доступ до Веб-сайтів Третіх Сторін,
            використовувати та/або встановити будь-який Вміст третіх сторін, Ви робите
            це на власний ризик, і Ви повинні знати, що ці Умови використання Нашого
            Сайту більше не дійсні.
          </p>
          <br /><p>
            Вам слід ознайомитися з умовами використання та політикою, включаючи
            політику конфіденційності та збору даних, будь-якого веб-сайту, на який Ви
            переходите із Нашого Сайту, або стосовно будь-яких програм, які Ви
            використовуєте або встановлюєте з Сайту. Будь-які покупки, які Ви робите
            через Веб-сайтів Третіх Сторін, здійснюватимуться через інші Веб-сайти та
            від інших компаній, і ми не несемо жодної відповідальності щодо таких
            покупок, які здійснюються виключно між Вами та відповідною третьою стороною.
          </p>
          <br /><p>
            Ви погоджуєтеся та визнаєте, що ми не схвалюємо продукти чи послуги, які
            пропонуються на сторонніх веб-сайтах, і Ви зобов’язуєтеся захистити Нас від
            будь-якої шкоди, спричиненої придбанням Вами таких продуктів чи послуг. Крім
            того, Ви зобов’язуєтеся захистити Нас від будь-яких втрат, які Ви зазнали,
            або шкоди, заподіяної Вам, яка будь-яким чином пов’язана з Вмістом Третіх
            Сторін або контактом з Веб-сайтами Третіх Сторін.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>УПРАВЛІННЯ САЙТОМ</strong>
          </h2>
          <p>Ми залишаємо за собою право, але не зобов’язання:</p>
          <p>(1) відстежувати Сайт на наявність порушень цих Умов використання;</p>
          <p>
            (2) вживати відповідних судових заходів проти будь-кого, хто на наш власний
            розсуд порушує закон або ці Умови використання, включаючи, але не
            обмежуючись, повідомлення про такого користувача правоохоронним органам;
          </p>
          <p>
            (3) на власний розсуд і без обмежень відмовляти, обмежувати доступ,
            обмежувати доступність або вимикати (наскільки це технологічно можливо)
            будь-який із ваших Внесків або будь-яку його частину;
          </p>
          <p>
            (4) на власний розсуд і без обмежень, попереджень чи відповідальності
            видаляти із Сайту чи іншим чином відключати всі файли та вміст, які мають
            надмірний розмір або будь-яким чином обтяжливі для наших систем;
          </p>
          <p>
            (5) іншим чином керувати Сайтом таким чином, щоб захистити наші права та
            власність і сприяти належному функціонуванню Сайту.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ</strong>
          </h2>
          <p>
            Ми дбаємо про конфіденційність і безпеку даних. Будь ласка, перегляньте нашу
            повну Політику конфіденційності, розміщену на Сайті. Використовуючи Сайт, ви
            погоджуєтеся дотримуватися нашої Політики конфіденційності.
          </p>
          <br /><p>
            Для використання Сайту та/або Вмісту ми можемо вимагати особистих даних або
            інформації, включаючи Ваше ім’я, адресу електронної пошти, номер телефону,
            адресу, платіжну інформацію, дату народження, уподобання, інтереси,
            призначення або іншу особисту інформацію («Конфіденційна Інформація”), або
            Ви можете запропонувати або надати нам коментар, фотографію, зображення,
            відео або будь-яку іншу інформацію під час використання або участі в Сайті
            та/або Контенті (“Інша інформація”). Надаючи нам таку Конфіденційну чи іншу
            інформацію, Ви надаєте нам дозвіл на використання та зберігання такої
            інформації відповідно до нашої Політики конфіденційності. Ми, у свою чергу,
            докладемо всіх зусиль, щоб Ваша конфіденційна інформація була безпечною та
            конфіденційною відповідно до цих Умов використання і нашої повної Політики
            конфіденційності, яку можна знайти на Сайті.
          </p>
          <br /><p>
            Однак через особливості Інтернету ми не можемо повністю забезпечити або
            гарантувати безпеку Вашої Конфіденційної інформації або будь-яких інших
            даних або інформації, що передаються нам або через наші служби; тому
            надсилання Конфіденційної інформації, даних або іншої інформації
            здійснюється на Ваш власний ризик. Ми вживаємо розумні заходи безпеки, щоб
            запобігти втраті, неправильному використанню та зміні інформації, отриманої
            від Вас, але ми не гарантуємо, що ми можемо запобігти будь-якій такій
            втраті, неправильному використанню для Вас чи будь-якої третьої сторони
            будь-якої такої втрати, неправильного використання або зміни.
          </p>
          <br /><p>
            Якщо Ви вважаєте, що будь-яка Ваша конфіденційна інформація є неправильною
            або неповною, зв’яжіться з нами якомога швидше. Ми негайно виправимо
            будь-яку конфіденційну інформацію, яку буде визнано неправильною.
          </p>
          <br /><p>
            <strong>Як ми використовуємо </strong>
            <strong>Вашу конфіденційну інформацію.</strong> Ми запитуємо та можемо
            запросити різні особисті дані та/або конфіденційну інформацію, щоб зрозуміти
            Ваші потреби та надати Вам кращі послуги. Крім того, ми можемо
            використовувати такі дані та Конфіденційну інформацію з таких причин: (1)
            для внутрішнього обліку, (2) для покращення Сайту та/або Вмісту, (3) для
            періодичної розсилки рекламних повідомлень про нові Продукти, Послуги або
            інші спеціальні пропозиції, від яких Ви можете скасувати підписку в
            будь-який час, (4) для отримання сукупних даних, що не ідентифікуються, для
            дослідницьких цілей, (5) для налаштування відповідних Продуктів або Послуг,
            які Ви купуєте або використовуєте, відповідно до ваших інтересів та/або (6)
            для підтримки або спілкування, пов’язаного з Вашими запитами.
          </p>
          <br /><p>
            <strong>Зберігання.</strong> Усі дані та конфіденційна інформація
            зберігаються через систему керування даними. Доступ до цих даних і
            Конфіденційної інформації мають лише ті, хто допомагає керувати цією
            інформацією, щоб надсилати електронну пошту або іншим чином зв’язуватися з
            тими, хто хоче отримувати нашу інформацію. Ви погоджуєтеся та визнаєте, що
            ми, включаючи, але не обмежуючись, наша команда, персонал і філії, а також
            ті, хто керує системою керування даними, можемо мати доступ до Вашої
            Конфіденційної інформації.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ТЕРМІН ДІЇ ТА ЗАВЕРШЕННЯ</strong>
          </h2>
          <p>
            Ці Умови використання залишаються дійсними в повній силі, поки Ви
            використовуєте Сайт і в майбутньому, навіть після припинення Вами або нами.
            Ви маєте право в будь-який час припинити використання або участь у наших
            Продуктах чи Послугах, надіславши електронний лист на адресу
            {import.meta.env.VITE_MY_WORK_EMAIL}
          </p>
          <br /><p>
            БЕЗ ОБМЕЖЕННЯ БУДЬ-ЯКИХ ІНШИХ ПОЛОЖЕНЬ ЦИХ УМОВ ВИКОРИСТАННЯ САЙТОМ, МИ
            ЗАЛИШАЄМО ЗА СОБОЮ ПРАВО НА НАШ РОЗСУД ТА БЕЗ ПОВІДОМЛЕННЯ ЧИ
            ВІДПОВІДАЛЬНОСТІ ВІДМОВИТИ У ДОСТУПІ ДО САЙТУ ТА ЙОГО ВИКОРИСТАННЯ
            (ВКЛЮЧАЮЧИ БЛОКУВАННЯ ПЕВНИХ IP-АДРЕС) БУДЬ-ЯКІЙ ОСОБІ З БУДЬ-ЯКОЇ ПРИЧИНИ
            АБО БЕЗ ПРИЧИН, ВКЛЮЧАЮЧИ, НЕ ОБМЕЖУЮЧИСЬ, ПОРУШЕННЯ БУДЬ-ЯКИХ ЗАЯВ,
            ГАРАНТІЙ ЧИ УГОД, ЩО ЗНАХОДЯТЬСЯ В ЦИХ УМОВАХ ВИКОРИСТАННЯ АБО БУДЬ-ЯКОГО
            ВІДПОВІДНОГО ЗАКОНУ ЧИ НОРМАТИВНОГО ПРАВА. МИ МОЖЕМО ПРИПИНИТИ ВАШЕ
            ВИКОРИСТАННЯ АБО УЧАСТЬ У САЙТІ АБО ВИДАЛИТИ ВАШ ОБЛІКОВИЙ ЗАПИС ТА/АБО
            БУДЬ-ЯКИЙ ВМІСТ ЧИ ІНФОРМАЦІЮ, ЩО ВИ ОПУБЛІКУВАЛИ В БУДЬ-ЯКИЙ ЧАС, БЕЗ
            ПОПЕРЕДЖЕННЯ, НА НАШ РОЗСУД.
          </p>
          <br /><p>
            Якщо ми припиняємо або призупиняємо дію Вашого облікового запису з будь-якої
            причини, Вам забороняється реєструвати та створювати новий обліковий запис
            під своїм іменем, фальшивим чи позиченим іменем або ім’ям будь-якої третьої
            сторони, навіть якщо Ви можете діяти від імені третьої сторони.
          </p>
          <br /><p>
            Окрім припинення або призупинення дії Вашого облікового запису, ми залишаємо
            за собою право вжити відповідних судових заходів, включаючи, без обмежень,
            цивільні, кримінальні та судові заборони.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>МОДИФІКАЦІЇ ТА ПЕРЕГЛЯД</strong>
          </h2>
          <p>
            Ми залишаємо за собою право змінювати, модифікувати або видаляти вміст Сайту
            в будь-який час і з будь-якої причини на власний розсуд без попередження.
            Проте ми не зобов’язані оновлювати будь-яку інформацію на нашому Сайті. Ми
            також залишаємо за собою право в будь-який час змінювати або припиняти весь
            Сайт або його частину без попередження.
          </p>
          <br /><p>
            Ми не несемо відповідальності перед Вами чи будь-якою третьою стороною за
            будь-які модифікації, зміни ціни, призупинення або припинення роботи Сайту.
          </p>
          <br /><p>
            Ми не можемо гарантувати, що Сайт буде доступний у будь-який час. У нас
            можуть виникнути проблеми з обладнанням, програмним забезпеченням або інші
            проблеми або нам знадобитися виконати технічне обслуговування Сайту, що
            призведе до перебоїв, затримок або помилок.
          </p>
          <br /><p>
            Ми залишаємо за собою право змінювати, переглядати, оновлювати, призупиняти,
            припиняти або іншим чином змінювати Сайт у будь-який час і з будь-якої
            причини без повідомлення Вас. Ви погоджуєтеся з тим, що ми не несемо жодної
            відповідальності за будь-які втрати, пошкодження або незручності, спричинені
            вашою нездатністю отримати доступ або використовувати Сайт під час простою
            або припинення роботи Сайту.
          </p>
          <br /><p>
            Ніщо в цих Умовах використання не буде тлумачитися як зобов’язання
            підтримувати Сайт або надавати будь-які виправлення, оновлення чи випуски у
            зв’язку з ним.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>УРЯДОВЕ ПРАВО</strong>
          </h2>
          <p>
            Ці Умови використання і використання Вами Сайту регулюються законодавством
            України, незалежно від конфлікту правових норм.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ВИРІШЕННЯ СПОРІВ</strong>
          </h2>
          <p>
            Сподіваємося, що якщо у нас колись виникнуть розбіжності, ми зможемо
            вирішити їх дружньо через листування електронною поштою. Однак, якщо ми не
            зможемо досягти вирішення протягом розумного часу, Ви погоджуєтеся, що
            єдиним методом правового вирішення спору, який буде використовуватися, є
            обов’язковий арбітраж перед одним арбітром, обраним спільно, відповідно до
            Регламенту Української арбітражної асоціації. Перш ніж звернутися до
            арбітражу, Ви повинні надіслати нам електронний лист на адресу
            {import.meta.env.VITE_MY_WORK_EMAIL}
          </p>
          <br /><p>
            і вказати усі Ваші причини незадоволення Вашим продуктом, послугою. Ви
            розумієте та погоджуєтеся, що єдиним засобом правового захисту, який може
            бути наданий Вам через арбітраж, є повне відшкодування Вашого платежу,
            здійсненого на момент оплати нашого Продукту та/або Послуги. Вам не можуть
            бути надані жодні інші дії чи фінансові винагороди за непрямі збитки чи
            будь-які інші види збитків. Ми обоє погоджуємося з тим, що рішення арбітра є
            остаточним і обов’язковим і може бути прийнято як рішення в будь-якому суді
            відповідної юрисдикції.
          </p>
          <br /><p>
            Ви також погоджуєтеся, що якщо арбітраж відбудеться, він буде проведений у
            Києві, Україна, і сторона, яка перемогла, матиме право на всі розумні
            гонорари адвокатів і всі витрати, необхідні для виконання рішення арбітра.
          </p>
          <br /><p>
            У разі суперечки між нами Ви погоджуєтеся не брати участі в будь-якій
            поведінці чи спілкуванні, зокрема в соціальних мережах, спрямованому на
            приниження нас, нашої Компанії чи будь-яких наших Продуктів і/або Послуг.
            Звичайно, якщо цього вимагає закон або арбітраж, Вам не заборонено ділитися
            своїми думками та думками в рамках судового процесу.
          </p>
          <br /><p>
            Якщо будь-які умови цих Умов використання з будь-якої причини тлумачаться як
            недійсні або такі, що не мають законної сили, це не впливає на дійсність або
            можливість виконання будь-яких інших умов, яким надається повна сила.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ПОМИЛКИ ТА УПУЩЕННЯ</strong>
          </h2>
          <p>
            Ми не надаємо жодних гарантій щодо точності, своєчасності, ефективності,
            повноти чи придатності інформації на Сайті, включаючи будь-який Вміст.
            Робиться все можливе, щоб надати Вам найточнішу та найновішу інформацію, але
            оскільки кількість наукових досліджень постійно збільшується досить швидко,
            ми не можемо нести відповідальність за точність Вмісту. Ви визнаєте, що така
            інформація може містити неточності чи помилки, і ми не несемо
            відповідальності за будь-які такі неточності чи помилки в повному обсязі,
            дозволеному законом.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ДИСКЛЕЙМЕР</strong>
          </h2>
          <p>
            САЙТ НАДАЄТЬСЯ НА ОСНОВІ «ЯК Є ТА ЯК ДОСТУПНИЙ». ВИ ПОГОДЖУЄТЕСЯ, ЩО ВАШЕ
            КОРИСТУВАННЯ САЙТОМ ТА НАШИМИ ПОСЛУГАМИ ЗДІЙСНЮЄТЬСЯ ЛИШЕ НА ВАШ ВЛАСНИЙ
            РИЗИК. У ПОВНОМУ ОБСЯЗІ, ДОЗВОЛЕНОМУ ЗАКОНОМ, МИ ВІДМОВЛЯЄМОСЯ ВІД БУДЬ-ЯКИХ
            ГАРАНТІЙ, ЯВНИХ АБО НЕПРЯМИХ, ЩОДО САЙТУ ТА ВИКОРИСТАННЯ ЙОГО ВАМИ,
            ВКЛЮЧАЮЧИ, АЛЕ НЕ ОБМЕЖУЮЧИСЬ, НЕПРЯМІ ГАРАНТІЇ ПРИДАТНОСТІ ДЛЯ ПРОДАЖУ,
            ПРИДАТНОСТІ ДЛЯ КОНКРЕТНОЇ МЕТИ ТА НЕПОРУШЕННЯ ПРАВ. МИ НЕ ДАЄМО ЖОДНИХ
            ГАРАНТІЙ АБО ЗАЯВ ЩОДО ТОЧНОСТІ АБО ПОВНОТИ ВМІСТУ САЙТУ АБО ВМІСТУ
            БУДЬ-ЯКИХ ВЕБ-САЙТІВ, ЩО ПОВ’ЯЗАНІ З ЦИМ САЙТОМ, І МИ НЕ НЕСЕМО ЖОДНОЇ
            ВІДПОВІДАЛЬНОСТІ ЗА БУДЬ-ЯКІ (1) ПОМИЛКИ АБО НЕТОЧНІСТЬ ВМІСТУ ТА МАТЕРІАЛІВ
            2) ТРАВМИ АБО ПОШКОДЖЕННЯ МАЙНА БУДЬ-ЯКОГО ХАРАКТЕРУ, ЩО ВІДБУЛИСЯ В
            РЕЗУЛЬТАТІ ВАШОГО ДОСТУПУ ДО САЙТУ ТА ВИКОРИСТАННЯ НИМ, (3) БУДЬ-ЯКИЙ
            НЕСАНКЦІОНОВАНИЙ ДОСТУП АБО ВИКОРИСТАННЯ НАШИХ БЕЗПЕЧНИХ СЕРВЕРІВ ТА/АБО
            БУДЬ-ЯКОЇ ОСОБИСТОЇ ІНФОРМАЦІЇ ТА/АБО ФІНАНСОВОЇ ІНФОРМАЦІЇ ЩО ЗБЕРІГАЄТЬСЯ
            В ЦИХ СЕРВЕРАХ, (4) БУДЬ-ЯКІ ПЕРЕРИВАННЯ АБО ПРИПИНЕННЯ ПЕРЕДАЧІ ІНФОРМАЦІЇ
            НА САЙТ АБО З САЙТУ, (5) БУДЬ-ЯКІ ПОМИЛКИ, ВІРУСИ, ТРОЯНИ АБО ЩОСЬ СХОЖЕ, ЩО
            МОЖЕ БУТИ ПЕРЕДАНО НА САЙТ АБО ЧЕРЕЗ САЙТ БУДЬ-ЯКОЮ ТРЕТЬОЮ СТОРОНОЮ ТА/АБО
            ( 6) БУДЬ-ЯКІ ПОМИЛКИ ЧИ УПУЩЕННЯ У БУДЬ-ЯКОМУ ВМІСТІ ТА МАТЕРІАЛАХ АБО
            БУДЬ-ЯКІ ВТРАТИ ЧИ ПОШКОДЖЕННЯ БУДЬ-ЯКОГО ВИДУ, СТВОРЕНОГО В РЕЗУЛЬТАТІ
            ВИКОРИСТАННЯ БУДЬ-ЯКОГО ВМІСТУ, ОПУБЛІКОВАНОГО, ПЕРЕДАННОГО АБО ІНШИМ
            СПОСОБОМ ЗРОБЛЕНОГО ДОСТУПНИМ ЧЕРЕЗ САЙТ. МИ НЕ ВИПРАВДОВУЄМО, НЕ СХВАЛЮЄМО,
            НЕ ГАРАНТУЄМО ТА НЕ НЕСЕМО ВІДПОВІДАЛЬНОСТІ ЗА БУДЬ-ЯКИЙ ПРОДУКТ АБО
            ПОСЛУГУ, ЩО РЕКЛАМУЄТЬСЯ АБО ПРОПОНУЄТЬСЯ ТРЕТЬОЮ СТОРОНОЮ НА НАШОМУ САЙТІ,
            БУДЬ-ЯКОМУ ГІПЕРПОСИЛАННЮ НА ІНШИЙ САЙТ АБО БУДЬ-ЯКИЙ ІНШИЙ ВЕБ-САЙТ АБО
            МОБІЛЬНИЙ ДОДАТОК, ЯКИЙ РОЗМІЩУЄТЬСЯ НА БУДЬ-ЯКОМУ БАНЕРІ АБО ІНШІЙ РЕКЛАМІ
            І МИ НЕ БУДЕМО СТОРОНОЮ АБО В БУДЬ-ЯКИЙ СПОСІБ НЕСТИ ВІДПОВІДАЛЬНІСТЬ ЗА
            МОНІТОРИНГ БУДЬ-ЯКИХ ОПЕРАЦІЙ МІЖ ВАМИ ТА БУДЬ-ЯКИМИ СТОРОННІМИ
            ПОСТАЧАЛЬНИКАМИ ПРОДУКТІВ АБО ПОСЛУГ.
          </p>
          <br /><p>
            ЦЕЙ ВМІСТ ПРИЗНАЧЕНИЙ ЛИШЕ ДЛЯ ІНФОРМАЦІЙНИХ ТА НАВЧАЛЬНИХ ЦІЛЕЙ І НЕ
            ПОВИНЕН СПРИЙМАТИСЯ ЯК МЕДИЧНА ПОРАДА, ПОРАДА ЩОДО ЗДОРОВ’Я, ПСИХОЛОГІЧНА,
            ЮРИДИЧНА ТА/АБО ФІНАНСОВА ПОРАДА. МИ НЕ НАДАЄМО МЕДИЧНИХ ПОРАД АБО ПОСЛУГ ПО
            ЗДОРОВ’Ю АБО ХАРЧУВАННЮ І НЕ НАМАГАЄМОСЯ ПРОВОДИТИ ДІАГНОСТИКУ, ЛІКУВАННЯ,
            ПРОФІЛАКТИКУ ТА/АБО ВИЛІКОВУВАННЯ БУДЬ-ЯКИМ СПОСОБОМ БУДЬ-ЯКИХ ПСИХІЧНИХ,
            ЕМОЦІЙНИХ, ФІЗИЧНИХ ПРОБЛЕМ, ЗАХВОРЮВАНЬ АБО СТАНІВ. В ПОВНОМУ ОБСЯЗІ,
            НАСКІЛЬКИ ЦЕ ДОЗВОЛЕНО ЗАКОНОМ, МИ ПРЯМО ВИКЛЮЧАЄМО БУДЬ-ЯКУ
            ВІДПОВІДАЛЬНІСТЬ ЗА БУДЬ-ЯКІ ПРЯМІ, НЕПРЯМІ АБО ПОБІЧНІ ЗБИТКИ АБО ШКОДУ,
            ПОНЕСЕНІ ВАМИ АБО ІНШИМИ ОСОБАМИ У ЗВ’ЯЗКУ З САЙТОМ ТА/АБО ВМІСТОМ,
            ВКЛЮЧАЮЧИ, АЛЕ НЕ ОБМЕЖУЮЧИСЬ, БУДЬ-ЯКУ ВІДПОВІДАЛЬНІСТЬ ЗА БУДЬ-ЯКУ ШКОДУ,
            ВТРАТИ, ПОШКОДЖЕННЯ, ВТРАЧЕНІ ПРИБУТКИ, ФІЗИЧНІ, ПСИХІЧНІ, ЕМОЦІЙНІ, ДУХОВНІ
            ТРАВМИ, ШКОДУ, ВТРАТУ ДОХОДУ, БІЗНЕСУ ТА БУДЬ-ЯКІ ІНШІ ВТРАТИ АБО ШКОДИ
            БУДЬ-ЯКОГО ВИДУ, ВИКЛИКАНІ НЕДБАЛІСТЮ, ПОРУШЕННЯМ КОНТРАКТУ АБО ІНШИМ ЧИНОМ,
            НАВІТЬ ЯКЩО ПЕРЕДБАЧЕНО.
          </p>
          <br /><p>
            ВСІ ВАШІ ДІЇ ПОВИННІ КЕРУВАТИСЯ ВАШИМ РОЗСУДОМ І БУТИ ОБЕРЕЖНИМИ ДЕ ЦЕ
            МОЖЛИВО, ТАК САМО ЯК І ПРИДБАННЯ БУДЬ-ЯКОГО ПРОДУКТУ ЧИ СЕРВІСУ ЧЕРЕЗ
            БУДЬ-ЯКИЙ МЕТОД ПОКУПКИ.
          </p>
          <br /><p>
            МИ НАМАГАЄМОСЯ ЗАБЕЗПЕЧИТИ ДОСТУПНІСТЬ ТА БЕЗПЕРЕБІЙНИЙ ДОСТУП ДО САЙТУ ТА
            КОНТЕНТУ. ОДНАК МИ НЕ МОЖЕМО ГАРАНТУВАТИ, ЩО ВАШ ДОСТУП НЕ БУДЕ ПРИЗУПИНЕНО
            АБО ОБМЕЖЕНО ЧАС ВІД ЧАСУ, ЗОКРЕМА ДЛЯ ПРОВЕДЕННЯ ТЕХНІЧНОГО ОБСЛУГОВУВАННЯ
            АБО ОНОВЛЕНЬ, ХОЧА МИ БУДЕМО НАМАГАТИСЯ ОБМЕЖИТИ ЧАСТОТУ ТА ТРИВАЛІСТЬ
            ПРИЗУПИНЕННЯ АБО ОБМЕЖЕНЬ. В ПОВНОМУ ОБСЯЗІ, НАСКІЛЬКИ ЦЕ ДОЗВОЛЕНО ЗАКОНОМ,
            МИ НЕ НЕСЕМО ВІДПОВІДАЛЬНОСТІ ПЕРЕД ВАМИ ЗА БУДЬ-ЯКІ ЗБИТКИ АБО ПОВЕРНЕННЯ
            КОШТІВ, ЯКЩО САЙТ ТА/АБО ВМІСТ, ПОВНІСТЮ АБО ЧАСТКОВО, СТАНУТЬ НЕДОСТУПНИМИ
            АБО ДОСТУП ДО НИХ СТАНЕ ПОВІЛЬНИМ ЧЕРЕЗ БУДЬ-ЯКУ ПРИЧИНУ, ВКЛЮЧАЮЧИ АЛЕ НЕ
            ОБМЕЖУЮЧИСЬ ОНОВЛЕННЯМИ, ОБСЯГОМ ІНТЕРНЕТ-ТРАФІКУ, ПЕРЕВАНТАЖЕННЯМ СЕРВЕРІВ,
            ЗАГАЛЬНИМИ ЗБОЯМИ МЕРЕЖІ АБО ІНШИМИ ПРИЧИНАМИ.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ОБМЕЖЕННЯ ВІДПОВІДАЛЬНОСТІ</strong>
          </h2>
          <p>
            МИ АБО НАШІ ДИРЕКТОРИ, СПІВРОБІТНИКИ, ПАРТНЕРИ АБО АГЕНТИ НЕ НЕСЕМО
            ВІДПОВІДАЛЬНОСТІ ПЕРЕД ВАМИ АБО БУДЬ-ЯКОЮ ТРЕТЬОЮ СТОРОНОЮ ЗА БУДЬ-ЯКІ
            ПРЯМІ, НЕПРЯМІ, НАСЛІДКОВІ, ВИПАДКОВІ, СПЕЦІАЛЬНІ АБО ШТРАФНІ ЗБИТКИ,
            ВКЛЮЧАЮЧИ, АЛЕ НЕ ОБМЕЖУЮЧИСЬ, БУДЬ-ЯКІ ПОШКОДЖЕННЯ, ВТРАЧЕНИЙ ПРИБУТОК,
            ВТРАТУ ДАНИХ АБО БУДЬ-ЯКІ ІНШІ ЗБИТКИ, ЩО ВИНИКАЮТЬ ВНАСЛІДОК ВИКОРИСТАННЯ
            ВАМИ САЙТУ, НАВІТЬ ЯКЩО НАС ПОВІДОМИЛИ ПРО МОЖЛИВІСТЬ ТАКИХ ЗБИТКІВ.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ВІДШКОДУВАННЯ</strong>
          </h2>
          <p>
            Ви погоджуєтеся захищати, відшкодовувати та звільняти нас, включаючи наші
            дочірні компанії, партнерів та всіх наших відповідних посадових осіб,
            агентів, партнерів і співробітників, від будь-яких втрат, пошкоджень,
            відповідальності, претензій або вимог, включаючи комісії та витрати на
            адвокатів, здійснені будь-якою третьою стороною внаслідок: (1) Ваших
            Внесків; (2) використання Сайту; (3) порушення цих Умов використання; (4)
            будь-яке порушення Ваших заяв і гарантій, викладених у цих Умовах
            використання; (5) порушення Вами прав третьої сторони, включаючи, але не
            обмежуючись правами інтелектуальної власності; або (6) будь-які явні
            шкідливі дії щодо будь-якого іншого користувача Сайту, з яким Ви
            познайомилися через Сайт.
          </p>
          <br /><p>
            Незважаючи на вищезазначене, ми залишаємо за собою право за Ваш рахунок
            взяти на себе виключний захист і контроль у будь-якій справі, за яку Ви
            повинні відшкодувати нам збитки, і Ви погоджуєтеся співпрацювати за свій
            рахунок у нашому захисті таких претензій. Ми докладемо розумних зусиль, щоб
            повідомити Вас про будь-яку таку претензію, дію чи провадження, які
            підпадають під цю компенсацію, коли нам стане відомо про це.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ДАНІ КОРИСТУВАЧІВ</strong>
          </h2>
          <p>
            Ми зберігатимемо певні дані, які Ви передаєте на Сайт з метою керування
            Сайтом, а також дані, пов’язані з Вашим використанням Сайту. Незважаючи на
            те, що ми виконуємо регулярне резервне копіювання даних, Ви несете повну
            відповідальність за всі дані, які Ви передаєте або які стосуються будь-якої
            діяльності, яку Ви здійснювали на Сайті.
          </p>
          <br /><p>
            Ви погоджуєтеся з тим, що ми не несемо відповідальності перед Вами за
            будь-яку втрату або пошкодження будь-яких таких даних, і цим Ви
            відмовляєтеся від будь-яких прав на позов проти нас у зв’язку з будь-якою
            такою втратою або пошкодженням таких даних.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ЕЛЕКТРОННІ КОМУНІКАЦІЇ, ТРАНЗАКЦІЇ ТА ПІДПИСИ</strong>
          </h2>
          <p>
            Відвідування Сайту, надсилання нам електронних листів, придбання наших
            Продуктів, Послуг та заповнення онлайн-форм становлять електронні
            комунікації. Ви погоджуєтеся отримувати електронні повідомлення та
            погоджуєтеся, що всі угоди та інші повідомлення, які ми надаємо Вам в
            електронному вигляді, електронною поштою та на Сайті, задовольняють будь-які
            юридичні вимоги щодо письмової форми такого повідомлення.
          </p>
          <br /><p>
            ТАКИМ ЧИНОМ ПРОДОВЖУЮЧИ КОРИСТУВАТИСЯ НАШИМ САЙТОМ ВИ ПОГОДЖУЄТЕСЯ НА
            ВИКОРИСТАННЯ ЕЛЕКТРОННИХ ПІДПИСІВ, КОНТРАКТІВ, ЗАМОВЛЕНЬ ТА ІНШИХ ЗАПИСІВ,
            ТА НА ЕЛЕКТРОННУ ДОСТАВКУ ПОВІДОМЛЕНЬ, ПОЛІТИК ТА ЗАПИСІВ ПРО ТРАНЗАКЦІЇ,
            ІНІЦІЙОВАНІ АБО ЗАВЕРШЕНІ НАМИ АБО ЧЕРЕЗ САЙТ.
          </p>
          <br /><p>
            Також продовжуючи користуватися нашим Сайтом Ви відмовляєтеся від будь-яких
            прав або вимог згідно з будь-якими статутами, нормативними актами,
            правилами, розпорядженнями чи іншими законами в будь-якій юрисдикції, які
            вимагають оригінального підпису або доставки чи збереження неелектронних
            записів, або щодо платежів чи надання кредитів будь-якими іншими способами
            ніж електронні засоби.
          </p>
          <br /><p>
            Уся інформація, отримана під час покупки чи транзакції щодо наших Продуктів
            та/або Послуг, а також уся інформація, яку Ви надаєте в рамках транзакції,
            наприклад, Ваше ім’я, адреса, спосіб оплати, номер кредитної картки та
            платіжна інформація, може бути зібрана як нами, так і компанією, яку ми
            використовуємо для приймання платежів на нашому сайті. Згідно з нашою
            Політикою конфіденційності, переконайтеся, що Ви ознайомилися з політикою
            конфіденційності нашого платіжного процесора.
          </p>
          <br /><p>
            На даний момент ми використовуємо www.wayforpay.com як нашого основного
            платіжного процесора. Це означає, що якщо Ви робите покупку за допомогою
            облікових даних кредитної картки, відмінної від української, Ваш банк може
            заблокувати платіж як підозрілий, оскільки валютою є гривня, а не долар США.
            Отже, Вам доведеться зв’язатися зі службою підтримки Вашого банку та
            попросити їх схвалити платіж. Можуть застосовуватися додаткові комісії.
          </p>
          <br /><p>
            Ви погоджуєтеся купувати товари чи послуги лише для себе чи для іншої особи,
            для якої Ви маєте право це робити за законом або від якої Ви отримали чітку
            згоду надати її ім’я, адресу, спосіб оплати, номер кредитної картки та
            платіжну інформацію.
          </p>
          <br /><p>
            Ви погоджуєтеся нести фінансову відповідальність за всі покупки, зроблені
            Вами або особою, яка діє від Вашого імені. Ви погоджуєтеся використовувати
            наші Продукти, Послуги лише в законних, некомерційних цілях, а не в
            спекулятивних, фальшивих, шахрайських або незаконних цілях.
          </p>
          <br /><p>
            Якщо Ви робите покупку в одного з наших партнерів або будь-якої іншої
            фізичної особи чи компанії за посиланням, наданим у наших Продуктах чи
            Послугах або через них («Мерчант»), уся інформація, отримана під час Вашої
            покупки чи транзакції, і вся інформація, яку Ви надаєте як частину
            транзакції, наприклад, номер Вашої кредитної картки та контактну інформацію,
            також можуть бути зібрані мерчантом та його компанією з обробки платежів.
            Ваша участь, листування або ділові відносини з будь-яким партнером, фізичною
            особою чи компанією через наші Продукти чи Послуги, а також усі умови
            придбання, заяви чи гарантії, пов’язані з оплатою, відшкодуванням та/або
            доставкою, пов’язаною з Вашою покупкою, є виключно між Вами і Мерчантом. Ви
            погоджуєтеся з тим, що ми не несемо відповідальності за будь-які втрати,
            пошкодження, відшкодування або інші питання будь-якого роду, які виникли в
            результаті таких операцій з Мерчантом.
          </p>
          <br /><p>
            Компанії, що займаються обробкою платежів, і Мерчанти можуть мати політики
            конфіденційності та збору даних, які відрізняються від наших. Ми не несемо
            жодної відповідальності за цю незалежну політику компаній з обробки платежів
            і Мерчантів. Крім того, коли Ви робите певні покупки через наші Продукти або
            Послуги, на Вас можуть поширюватися додаткові Умови використання компанії,
            що займається обробкою платежів, Мерчанта або нас, які стосуються саме Вашої
            покупки. Щоб отримати додаткову інформацію про Мерчанта та його Умови
            використання, які можуть застосовуватися, відвідайте веб-сайт цього Мерчанта
            та натисніть на його інформаційні посилання або зв’яжіться безпосередньо з
            Мерчантом.
          </p>
          <br /><p>
            Ви звільняєте нас, наших партнерів, нашу компанію з обробки платежів і
            Мерчантів від будь-яких збитків, яких Ви зазнаєте, і погоджуєтеся не
            пред’являти жодних претензій до нас або до них, що виникають у результаті
            Вашої покупки через наш веб-сайт або його Вміст.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ПОЛІТИКА ПОВЕРНЕННЯ КОШТІВ</strong>
          </h2>
          <p>
            Для нас важливо, щоб Ви були задоволені нашими продуктами та послугами, і ми
            щиро віримо, що наші продукти можуть допомогти Вам покращити Ваше життя.
            Отже, щоб полегшити Вам прийняття рішення, якщо інше не передбачено законом
            або в окремих частинах Сайту, ми пропонуємо 30-денну гарантію повернення
            грошей за будь-який наш платний Продукт, Послугу.
          </p>
          <br /><p>
            Щоб повернути кошти Вам потрібно написати нам електронного листа на пошту{" "}
            <a href={`mailto:${import.meta.env.VITE_MY_WORK_EMAIL}`}>{import.meta.env.VITE_MY_WORK_EMAIL}</a> та
            вказати свої платіжні дані, які Ви використовували для оплати (ПІБ, email,
            телефон) та причину повернення коштів.
          </p>
          <br /><h2 className="text-[#2a7a2a]">
            <strong>ЗВ’ЯЖІТЬСЯ З НАМИ</strong>{" "}
          </h2>
          <p>
            Якщо у Вас виникли запитання щодо Сайту та/або Вмісту, Ви можете надіслати
            електронний лист на адресу {import.meta.env.VITE_MY_WORK_EMAIL}, і ми зробимо все
            можливе, щоб швидко відповісти на Ваше запитання.
          </p>
        </>

      </>

    </div>
  );
}
